export default "__VITE_ASSET__d4cb02ac__"